import { IAppState } from '../reducers'

export const getApprovalState = (state: IAppState) => state.approval
